import styled from "styled-components";

export const CheckboxWithLabel = styled.span`
  display: inline-flex;
  width: 100%;
  align-items: center;
  > button {
    flex-shrink: 0;
  }
  > label {
    margin-left: 0.7rem;
  }
`;
